<template>
  <div>
    <app-step-confirmation>
      <p>
        Lorem ipsum dolor sit amet, sit detraxit efficiantur ne, quando tollit te mel. Illum luptatum forensibus mel no, eum id populo salutandi prodesset. Sed ex nisl reque eruditi, ignota mnesarchum vis te. Eros modus accusam ex mei, altera pertinax quo ut.
      </p>
    </app-step-confirmation>
    <collapsible-section class='_pt0 _pb0' :collapsed='false'>
      <template #headerText>
        <p class='color-leaf'>{{fullName}}</p>
      </template>
      <template #headerActions>
        <router-link :to="{name: 'member-edit', params: { memberCk: memberCk, primarySubscriberMemberCk: primarySubscriberMemberCk }}" class="btn --sm white">Edit</router-link>
      </template>
      <template #collapsibleSection>
        <div container>
          <div class="">
            <div grid>
              <div column="3">
                <h4>Group:</h4>
                {{member.groupName}}
              </div>
              <div column="3">
                <h4>Subgroup:</h4>
                {{member.subgroupName}}
              </div>
              <div column="3">
                <h4>Class:</h4>
                {{member.classPlan}}
              </div>
              <div column="3">
                <h4>Plan:</h4>
                {{member.planId}}
              </div>
            </div>
            <div grid class="_mts">
              <div column>
                <h4>Eyemed Member ID:</h4>
                {{member.eyemedMemberId}}
              </div>
              <div column>
                <h4>Client's Member ID</h4>
                {{clientId}}
              </div>
              <div column>
                <h4>Date of Birth:</h4>
                {{formatDate(member.dateOfBirth)}}
              </div>
              <div column>
                <h4>Email:</h4>
                {{member.emailAddress}}
              </div>
              <div column>
                <h4>Phone Number:</h4>
                {{member.homePhoneNumber}}
              </div>
            </div>
          </div>
        </div>
      </template>
    </collapsible-section>

    <collapsible-section class='_pt0 _pb0' :collapsed='false'>
      <template #headerText>
        <p class='color-leaf'>Member Demographics</p>
      </template>
      <template #collapsibleSection class='advanced-table-section-header'>
        <div container>
          <div row>
            <div class="_mbs">
              <div grid>
                <div column="3">
                    <h4>Address Line 1:</h4>
                    {{member.homeAddress.line1}}
                </div>
                <div column="3">
                  <h4>Address Line 2:</h4>
                  {{member.homeAddress.line2}}
                </div>
                <div column="3">
                  <h4>Address Line 3:</h4>
                  {{member.homeAddress.line3}}
                </div>
              </div>
              <div grid class="_mts">
                <div column="3">
                  <h4>Zip Code:</h4>
                  {{member.homeAddress.zip}}
                </div>
                <div column="3">
                  <h4>City:</h4>
                  {{member.homeAddress.city}}
                </div>
                <div column="3">
                  <h4>State:</h4>
                  {{member.homeAddress.state}}
                </div>
                <div column="3">
                  <h4>County:</h4>
                  {{member.homeAddress.county}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </collapsible-section>

    <collapsible-section class='_pt0 _pb0' :collapsed='false'>
      <template #headerText>
        <p class='color-leaf'>Reporting Codes</p>
      </template>
      <template #collapsibleSection class='advanced-table-section-header'>
        <div container>
          <div row>
            <div class="_mbs">
              <div grid>
                <div column>
                  <h4>Benefit Option:</h4>
                  {{member.benefitOption}}
                </div>
                <div column>
                  <h4>Division Code</h4>
                  {{member.divisionCode}}
                </div>
                <div column>
                  <h4>Location Code</h4>
                  {{member.location}}
                </div>
                <div column>
                  <h4>Company Code:</h4>
                  {{member.companyCode}}
                </div>
                <div column>
                  <h4>Client Group #:</h4>
                  {{member.clientGroupNbr}}
                </div>
              </div>
              <div grid class="_mts">
                <div column>
                  <h4 class="_ts2">Reporting Code 1:</h4>
                  {{member.reportingCodes[0]}}
                </div>
                <div column>
                  <h4 class="_ts2">Reporting Code 2:</h4>
                  {{member.reportingCodes[1]}}
                </div>
                <div column>
                  <h4 class="_ts2">Reporting Code 3:</h4>
                  {{member.reportingCodes[2]}}
                </div>
                <div column>
                  <h4 class="_ts2">Reporting Code 4:</h4>
                  {{member.reportingCodes[3]}}
                </div>
                <div column>
                  <h4 class="_ts2">Reporting Code 5:</h4>
                  {{member.reportingCodes[4]}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </collapsible-section>

    <collapsible-section class='_pt0 _pb0' :collapsed='false'>
      <template #headerText>
        <p class='color-leaf'>Privacy Address</p>
      </template>
      <template #collapsibleSection class='advanced-table-section-header'>
        <div container>
          <div row>
            <div class="_mbs">
              <div grid>
                <div column>
                  <h4>First Name:</h4>
                  {{member.privacyInfo.firstName}}
                </div>
                <div column>
                  <h4>Last Name:</h4>
                  {{member.privacyInfo.lastName}}
                </div>
                <div column>
                  <h4>Email:</h4>
                  {{member.privacyInfo.email}}
                </div>
                <div column>
                  <h4>Phone:</h4>
                  {{member.privacyInfo.phone}}
                </div>
              </div>
              <div grid class="_mts">
                <div column>
                  <h4>Address:</h4>
                  {{member.privacyInfo.address}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </collapsible-section>

    <collapsible-section class='_pt0 _pb0' :collapsed='false'>
      <template #headerText>
        <p class='color-leaf'>Language Assistance</p>
      </template>
      <template #collapsibleSection class='advanced-table-section-header'>
        <div container>
          <div row>
            <div class="_mbs">
              <div grid>
                <div column>
                  <h4>Ethnicity:</h4>
                  {{member.additionalMemberInfo.ethnicityCode}}
                </div>
                <div column>
                  <h4>Race:</h4>
                  {{member.additionalMemberInfo.raceCode}}
                </div>
                <div column>
                  <h4>Spoken Language:</h4>
                  {{member.additionalMemberInfo.spokenLanguage}}
                </div>
                <div column>
                  <h4>written Language:</h4>
                  {{member.additionalMemberInfo.writtenLanguage}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </collapsible-section>

    <collapsible-section class='_pt0 _pb0' :collapsed='false'>
      <template #headerText>
        <p class='color-leaf'>Related Family</p>
      </template>
      <template #headerActions>
        <router-link :to="{name: 'add-dependent', params: { primarySubscriberMemberCk: primarySubscriberMemberCk }}" class="_mls _mt0 btn white --sm">Add Dependent</router-link>
      </template>
      <template #collapsibleSection>
        <div container>
          <div v-for="(item, index) in member.relatedMembers" :key="index" class="_mbs">
            <div grid>
              <div column="3">
                <h4>Eyemed Member ID:</h4>
                {{item.eyemedMemberId}}
              </div>
              <div column="3">
                <h4>Client's Member ID:</h4>
                {{item.clientHealthId}}
              </div>
              <div column="4">
                <h3>
                {{item.firstName}}
                {{item.lastName}}
                </h3>
              </div>
              <div column="2">
                <router-link :to="{name: 'member-edit', params: { memberCk: item.memberCk }}" class="btn --sm white">Edit</router-link>
              </div>
            </div>
            <div grid>
              <div column="3">
                <h4>Date of Birth:</h4>
                {{formatDate(item.dateOfBirth)}}
              </div>
              <div column="3">
                <h4>Relationship:</h4>
                {{item.relationshipDescription}}
              </div>
              <div column="3">
                <h4>Effective Date:</h4>
                {{formatDate(item.coverageStartDate)}}
              </div>
              <div column="3">
                <h4>Term Date:</h4>
                {{formatDate(item.coverageEndDate)}}
              </div>
            </div>
          </div>
        </div>
      </template>
    </collapsible-section>

    <div class="_text-center _mts _mbs">
      <router-link :to="{ name: 'add-new-family' }" class='_mlxs btn green --sm'>Add Another Subscriber</router-link>
    </div>
  </div>
</template>

<script>
  import CollapsibleSection from '@sections/CollapsibleSection'
  import AppStepConfirmation from './Steps/StepConfirmation.vue'

  import RequestHelper from '@mixins/RequestHelper'
  import DateHelper from '@mixins/DateHelper'
  import formattable from '@mixins/formattable'

  import MemberApi from '@api/MemberApi'

  export default {
    mixins: [
      DateHelper,
      RequestHelper,
      formattable
    ],
    components: {
      AppStepConfirmation,
      CollapsibleSection
    },
    data() {
      return {
        submitting: false,
        member: {
          homeAddress: {},
          reportingCodes: new Array(5),
          privacyInfo: {},
          additionalMemberInfo: {}
        }
      }
    },
    computed: {
      primarySubscriberMemberCk(){
        return this.$store.getters['hiddenRouteData/getHiddenRouteData'].primarySubscriberMemberCk
      },
      memberCk() {
        return this.$store.getters['hiddenRouteData/getHiddenRouteData'].memberCk
      },
      fullName () {
        if (!this.member) {
          return ''
        }

        return `${this.member.firstName} ${this.member.lastName}`
      },
      clientId() {
        if (!this.member) {
          return ''
        }

        return this.member.clientHealthId
      }
    },
    created() {
      new MemberApi({ simulateExample: 'Member Details - Termed Member' }).memberDetails({
        params: {
          memberCk: this.memberCk,
          isEligibility: false,
          isBenefit: false,
          dateOfService: this.now()
        }
      })
        .then(res => {
          this.member = res.member
        })
        .catch(err => {
          console.warn(err)
        })
    }
  }
</script>
